
/**

 * Production-Safe Logger Utility

 * ALL logs are suppressed for security.

 */



const noop = () => {};



export const logger = {

  log: noop,

  error: noop,

  warn: noop,

  info: noop,

  debug: noop,

};



export const isDevelopment = () => false;

